import React from "react";
import { useAccount } from "../store/useWallet";
import { useRPMCars } from "../store/useRPMCars";


const config = {
  expectedNetwork: 'Matic',
  carsAddy: '0x1E27548fC78e294618442524A96D3Fe8E89dFE65'
}

const shortenAddy = (addy) => (
  `${addy.substr(0,6)}...${addy.substr(addy.length-4, addy.length)}`
);

const App = () => {

  const {
    provider,
    providerError,//add me
    network,
    account,
    block,
    balance,
    connect,
    disconnect
  } = useAccount();

  const {
    isBusy,
    mint
  } = useRPMCars(provider, account, block, config);

  return (
    <>

    <div className="menu">
      <div className="links">
        <li><a href="#">Home </a></li>
        <li><a href="#nfts">NFT,s </a></li>
        <li><a href="#crew">Pitcrew </a></li>
        <li><a href="#track">Track </a></li>
        <li><a href="#partners">Partners </a></li>
        <li>
          <a
            href="https://admin-94.gitbook.io/ready-player-motorsports/the-game/ready-player-motorsports"
            target="_blank"
            >Whitepaper
          </a>
        </li>
      </div>
    </div>
    <header className="header" id="header">
      <div className="logo">
        <a href="#"> <img src="./assets//images/logo.png" alt="" /></a>
      </div>
      <div className="links">
        <li><a href="#">Home </a></li>
        <li><a href="#nfts">NFTs </a></li>
        <li><a href="#crew">Pitcrew </a></li>
        <li><a href="#track">Track </a></li>
        <li><a href="#esg">ESG </a></li>
        <li><a href="#partners">Partners </a></li>
        <li>
          <a
            href="https://admin-94.gitbook.io/ready-player-motorsports/the-game/ready-player-motorsports"
            target="_blank"
            >Whitepaper
          </a>
        </li>
      </div>
      <div className="right">
        <span>
          <i className="fa-solid fa-magnifying-glass"></i>
        </span>

          {!account && <span className="wallet" onClick={() => connect()}
            >Connect
          </span>}
          {!!account && <button className="wallet"
            >{shortenAddy(account)}
            <div className="bars">
              <div></div>
              <div></div>
            </div>
          </button>}
          <div className="menuicon">
            <span><i className="fa-solid fa-bars"></i></span>
          </div>
          <div className="socials">
            <a href="https://twitter.com/ReadyPlayerMoto" target="_blank"
              ><i className="fa-brands fa-twitter"></i
            ></a>
            <a href="https://discord.gg/p7aZS6Z3pm" target="_blank"
              ><i className="fa-brands fa-discord"></i
            ></a>
          </div>
        </div>
      </header>

      <section className="hero">
      <div className="container">
        <img src="./assets/images/human.webp" alt="" />

        <div className="left">
          <div className="top">
            <h1>Are you ready ?</h1>
            <p>
              For the highest octane play-to-earn racing experience in the
              metaverse.
            </p>
            <div className="buttons">
              <a
                target="_blank"
                href="https://gamejolt.com/games/readyplayermotorsports0-01-7/707870"
                >Play Demo</a
              >
              {!!account ?  
                <a href="#" onClick={() => mint("1", account, balance)}>
                  <span>Mint NFT </span> <span>(100 Matic)</span>
                </a> :
                <a href="#" onClick={() => connect()}>
                  <span>Connect</span> <span></span>
                </a>
              }
            </div>
          </div>
          <div className="bottom">
            <h2>Play-to-Earn</h2>
            <p>
              Put money in your pocket while you blow the doors of the
              competition
            </p>
            <p>
              To learn why RPM is the right play-to-earn game for you, click
              below.
            </p>
            <a
              href="https://admin-94.gitbook.io/ready-player-motorsports/the-game/ready-player-motorsports"
              target="_blank"
              className="button"
              >learn more</a
            >
          </div>
        </div>
        <div className="right">
          <h1>How to play?</h1>
          <div className="boxes">
            <div className="box">
              <div className="box_inner">
                <div className="circle">1</div>
                <h4>Connect your wallet</h4>
                <p>Connect your NFT race car to start racing</p>
              </div>
            </div>
            <div className="box">
              <div className="box_inner">
                <div className="circle">2</div>
                <h4>Start Playing the Game</h4>
                <p>The more you play, the more chances you have to win</p>
              </div>
            </div>
            <div className="box">
              <div className="box_inner">
                <div className="circle">3</div>
                <h4>Win Prize Money</h4>
                <p>Players who finish in the top 5 win prizes</p>
              </div>
            </div>
          </div>
          <h3 className="rpm">RPM Tokenomics</h3>
          <img className="graph_img" src="./assets/images/graph.png" alt="" />
          <div className="highlights">
            <h2>Token highlights</h2>
            <ul>
              <li>
                The RPM is an ERC-20 token running on the Polygon Network.
              </li>
              <li>1,000,000,000 RPM tokens will be minted</li>
              <li>
                RPM tokens are the currency of the Ready Player Motorsports
                Ecosystem
              </li>
            </ul>
            <br/>
         

            <a
              href="https://admin-94.gitbook.io/ready-player-motorsports/the-game/ready-player-motorsports"
              target="_blank"
              className="button"
              >Learn more</a
            >
          </div>
        </div>
      </div>
    </section>

    <section className="nfts" id="nfts">
      <div className="container">
        <img src="./assets/images/NFT_phn.webp" alt="" />
      </div>
    </section>

    <section className="crew" id="crew">
      <div className="container">
        <img src="./assets/images/crews.webp" alt="" />
      </div>
    </section>

    <section className="track" id="track">
      <div className="container">
        <img src="./assets/images/track_phn.webp" alt="" />
      </div>
    </section>

    <section className="our_esg" id="esg">
      <div className="container">
        <img src="./assets/images/1.webp" alt="" />
        <div className="left">
          <div className="top">
            <h2>Our ESG</h2>
            <p style={{color: "#f7931e"}}>
              Creating a zero-carbon footprint gaming ecosystem
            </p>

            <h2>Coorest</h2>

            <p className="disable">
              Ready Player Motorsports collaborates with Coorest to offset any
              carbon emission created by the production or use of the game.
            </p>
            <p>
              Maintaining a zero-carbon emission game is something we are
              committed to.
              <br />
              <br />

              The Coorest NFT trees can been seen in the “Coorest Corner”
              section of the racetrack
            </p>

            <a
              href="https://admin-94.gitbook.io/ready-player-motorsports/the-game/ready-player-motorsports"
              target="_blank"
              className="more_button blue"
              >Learn More</a
            >
          </div>

          <div className="bottom">
            <h2>Giraffe Conservation Foundation</h2>
            <p>
              Our collaboration with Extinction Fighterz to create a giraffe nft
              collection allows us to aid the GCF in their efforts to protect
              the giraffe population. 100% of the nft sales go to the GCF.
              <br />
              <br />
            </p>
            <p className="disable">
              The Ready Player Motorsports Giraffes can be seen at various
              locations around the Onandaga Raceway
            </p>
            <br />
            <a
              href="https://admin-94.gitbook.io/ready-player-motorsports/the-game/ready-player-motorsports"
              target="_blank"
              className="more_button"
              >Learn More</a
            >
          </div>
        </div>
      </div>
    </section>

    <section className="partners" id="partners">
      <div className="container">
        <h2>Our Partners</h2>
        <img src="./assets/images/partners.webp" alt="" />
      </div>
    </section>
     
    </>
  );
}

export default App;
